import { render, staticRenderFns } from "./ElementNameTableColumn.vue?vue&type=template&id=a55effea&scoped=true"
import script from "./ElementNameTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementNameTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementNameTableColumn.vue?vue&type=style&index=0&id=a55effea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55effea",
  null
  
)

export default component.exports